import React, { useCallback, useMemo } from 'react';
import { Button, Modal, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import s from './s.module.less';
import { PATH } from 'constants/path';
import { getUrlParam } from 'utils/common';
import { CALENDLY_LINK, PRACTICE_FRONT_FROM } from 'constants/common';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import commonS from 'styles/common.module.less';
import WebinarBooking from 'components/WebinarBooking';

const SuccessPage = () => {
    const navigate = useNavigate();
    const from = getUrlParam('from');
    const [data, loadingHome] = useProviderHomeInfo();
    const [showWebinar, setShowWebinar] = React.useState(false);
    const practiceFrontCompleted = !!data?.practiceFrontCompleted;
    //practiceFrontCompleted = false;
    const klarityStarterSetUpCompleted = !!data?.klarityStarterSetUpCompleted;
    const klarityUser = !!data?.klarityUser;
    const klarityUserWithoutKiwiPlan = data?.klarityUserWithoutKiwiPlan;
    const isFree = data?.freeUser;

    const handleBackToHome = useCallback(() => {
        navigate(`${PATH.DASHBOARD}/${PATH.PROVIDER_HOME}`, { replace: true });
    }, [navigate]);

    const handleBack = useCallback(() => {
        navigate('/dashboard/marketing?mainTab=external', { replace: true });
    }, [navigate]);

    const handleToPFEdit = useCallback(() => {
        navigate(`/${PATH.CUSTOMIZE_PRACTICE_FRONT}`, { replace: true });
    }, [navigate]);

    const handleBackToPF = useCallback(() => {
        navigate('/dashboard/marketing?mainTab=external&subTab=practice-front', { replace: true });
    }, [navigate]);

    const handleToKlairtyProcess = useCallback(() => {
        navigate(`/${PATH.EHR_ONBOARDING}`, { replace: true });
    }, [navigate]);

    const handleWebinar = () => {
        setShowWebinar(true);
    };

    const renderButtons = useMemo(() => {
        if (klarityUser && klarityUserWithoutKiwiPlan) {
            return (
                <>
                    <Button type="primary" style={{ marginBottom: '24px' }} onClick={handleToKlairtyProcess}>Set up my practice</Button>
                    <Button type="ghost" style={{ color: '#00816B' }} onClick={handleBackToHome}>Back to home</Button>
                </>
            );
        }
        if (!practiceFrontCompleted) {
            return (
                <div className={s.btnWraoH}>
                    <Button type="primary" style={{ marginBottom: '12px', marginTop: '12px' }} onClick={handleToPFEdit}>Create Practice Front: estimated 2 mins</Button>
                    {/* {
                        !klarityUser && isFree &&
                        <Button
                            type="text"
                            className={s.btnText}
                            onClick={handleWebinar}
                        >Schedule a webinar now
                        </Button>
                    } */}
                </div>);
        } else if (from === PRACTICE_FRONT_FROM) {
            return <Button type="primary" ghost onClick={handleBackToPF}>Back to Practice Front page</Button>;
        }

        return <Button type="primary" onClick={handleBack}>Back to Channel page</Button>;
    }, [from, handleBack, handleBackToPF, handleToKlairtyProcess, handleToPFEdit, klarityStarterSetUpCompleted, klarityUser, klarityUserWithoutKiwiPlan, practiceFrontCompleted]);

    const descRender = useMemo(() => {
        if (klarityUser && klarityUserWithoutKiwiPlan) {
            return (
                <>
                    <p className={s.desc}>UniProfile submitted!</p>
                    <p className={s.exp}>🎉 Congratulations on completing your UniProfile!</p>
                    <p className={s.exp}>It will take 3-5 business days for our team to review.</p>
                    <p className={s.exp} style={{ marginTop: '38px' }}>Next step:</p>
                    <p className={s.exp} style={{ marginBottom: '24px' }}>Set up your practice by setting up EHR and selecting the necessary add-ons.</p>
                </>
            );
        }
        return (
            <>
                <p className={s.desc}>UniProfile submission successful!</p>
                <p className={s.exp} style={{ marginBottom: '24px' }}>Thank you for submitting your UniProfile. Our team will review your profile within the next 7 days. In the meantime, let’s explore how Kiwi can help you grow your practice by increasing your online visibility.</p>
            </>
        );
    }, [klarityUser, klarityUserWithoutKiwiPlan]);

    const renderNewSuccessPageForKiwi = () => {
        return (
            <>
                <p className={s.desc} style={{ width: '75%' }}>UniProfile submitted!</p>
                <p className={s.exp} style={{ width: '80%' }}>Thank you for submitting your UniProfile. Our team will review your profile within the next 7 days.</p>
                <p className={s.exp} style={{ width: '80%', margin: '24px 0 40px' }}>In the meantime, set up your services and availability so you&apos;re ready to start seeing patients once your profile is approved.</p>
                <Button type="primary" style={{ marginBottom: '12px' }} onClick={() => navigate('/service-setting')}>Set up services and availability</Button>
                {/* <Button type="text" className={s.btnText} onClick={handleWebinar}>Schedule a webinar now</Button> */}
            </>
        );
    };

    return (
        <div className={s.wrap}>
            <Spin spinning={loadingHome}>
                {
                    data &&
                    <div className={s.box}>
                        <div className={`${s.successImage} ${!practiceFrontCompleted ? s.pfSuccess : s.updateSuccess}`} />
                        {
                            !klarityUser ?
                                renderNewSuccessPageForKiwi() :
                                <>
                                    {descRender}
                                    {renderButtons}
                                </>
                        }
                    </div>
                }
            </Spin>
            <WebinarBooking
                show={showWebinar}
                link={CALENDLY_LINK.ACCOUNT_ACTIVATION}
                onClose={(show) => {
                    setShowWebinar(show);
                }}
            />
        </div>
    );
};

export default SuccessPage;
